import React from 'react'

function Activities() {
  return (
    <div>
      Hello Mustafa! This is the activities page.
    </div>
  )
}

export default Activities
